(ns app.front.view.public-notice.core
  (:require [app.front.ui.section :as section]
            [app.front.view.public-notice.contacts :as public-notice-contacts]
            [app.front.view.public-notice.documents :as public-notice-documents]
            [app.front.view.public-notice.neighbours :as public-notice-neighbours]
            [app.front.view.public-notice.public-link :as public-notice-link]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::section-visible?
  (fn [[_ target-id] _]
    [(rf/subscribe [::public-notice-documents/documents-visible? target-id])
     (rf/subscribe [::public-notice-neighbours/neighbours-visible? target-id])
     (rf/subscribe [::public-notice-contacts/contacts-visible? target-id])
     (rf/subscribe [::public-notice-link/public-link-visible? target-id])])
  (fn [[documents neighbours-visible contacts? public-link] _]
    (or documents
        neighbours-visible
        contacts?
        public-link)))


(defn section [{:keys [fsm-target] :as state} workspace-id]
  (let [show-contacts? (<sub [::public-notice-contacts/contacts-visible? (:db/id fsm-target)])]
    [section/initially-collapsed-section
     :public-notice-section
     state
     :public-notice/public-notice
     [public-notice-link/section fsm-target workspace-id]
     [public-notice-neighbours/section state]
     (when show-contacts?
       [public-notice-contacts/section fsm-target])
     [public-notice-documents/section state]]))
